import React from 'react';
import ContentLoader from 'react-content-loader';

export const SingleBarLoader = () => (
  <ContentLoader style={{ height: '5vh' }}>
    <rect x="0" y="17" rx="4" ry="4" width="400" height="20" />
  </ContentLoader>
);

export const DoubleBarLoader = () => (
  <ContentLoader style={{ height: '8vh' }}>
    <rect x="0" y="17" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="45" rx="4" ry="4" width="400" height="20" />
  </ContentLoader>
);

export const ThreeBarLoader = () => (
  <ContentLoader style={{ height: '10vh' }}>
    <rect x="0" y="17" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="45" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="72" rx="4" ry="4" width="400" height="20" />
  </ContentLoader>
);
